import React from 'react';
import { ExternalLink, ArrowUpRight } from 'lucide-react';
import { projects } from '../data/mock';

const ProjectsSection = () => {
  return (
    <section id="projetos" className="relative py-24 bg-black">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-t from-cyan-950/10 via-transparent to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-400/10 border border-cyan-400/20 mb-6">
            <span className="text-cyan-400 text-sm font-medium">Portfólio</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Projetos que <span className="text-cyan-400">entregamos</span>
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Conheça alguns dos projetos que desenvolvemos para nossos clientes. Cada solução é única e pensada para resolver problemas reais.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {projects.map((project) => (
            <div
              key={project.id}
              className="group relative bg-white/[0.02] border border-white/10 hover:border-cyan-400/50 transition-all duration-400 overflow-hidden"
            >
              {/* Header */}
              <div className="p-8 border-b border-white/10">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-2xl font-bold text-white group-hover:text-cyan-400 transition-colors mb-2">
                      {project.name}
                    </h3>
                    <div className="flex flex-wrap gap-2">
                      {project.tags.map((tag) => (
                        <span
                          key={tag}
                          className="px-3 py-1 text-xs font-medium bg-cyan-400/10 text-cyan-400 border border-cyan-400/20"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 flex items-center justify-center bg-white/5 hover:bg-cyan-400 border border-white/10 hover:border-cyan-400 transition-all duration-300 group/link"
                  >
                    <ArrowUpRight className="w-5 h-5 text-white/60 group-hover/link:text-black transition-colors" />
                  </a>
                </div>
                <p className="text-white/60 leading-relaxed">
                  {project.description}
                </p>
              </div>

              {/* Features */}
              <div className="p-8">
                <h4 className="text-sm font-medium text-white/40 uppercase tracking-wider mb-4">
                  Funcionalidades
                </h4>
                <div className="grid grid-cols-2 gap-3">
                  {project.features.map((feature) => (
                    <div
                      key={feature}
                      className="flex items-center gap-2 text-white/70"
                    >
                      <div className="w-1.5 h-1.5 bg-cyan-400" />
                      <span className="text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Visit Link */}
              <div className="px-8 pb-8">
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors text-sm font-medium"
                >
                  <ExternalLink className="w-4 h-4" />
                  Visitar {project.link.replace('https://', '')}
                </a>
              </div>

              {/* Hover effect overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-cyan-400/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
